import HNSColors from "../../../../ui library/HNSColors";

export default function AttorneyTotalReductionCapsule({ value }) {
  return (
    <div className="w-full">
      <div
        className="flex min-h-[50px] items-center justify-between rounded-[8px] px-4 py-2 text-sm font-medium"
        style={{
          backgroundColor: HNSColors.tertiary[900],
          color: HNSColors.primary[500],
        }}
      >
        <span className="font-semibold">Total Attorney&apos;s Reduction</span>
        <span>{value ? `$ ${value}` : "$ 0.00"}</span>
      </div>
    </div>
  );
}
